import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery,
  type UseQueryResult
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { failureFlagsQueryKeys } from 'queries/failure-flags/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { AxiosError } from 'axios'
import type { FailureFlag } from 'types/api/failure-flags/failure-flags'

function fetchFailureFlags({
  queryKey: [endpoint, teamId]
}: QueryFunctionContext<ReturnType<typeof failureFlagsQueryKeys.getFlags>>) {
  const endpointWithParams = getEndpointWithParams(endpoint, { teamId })

  return fetchQueryData<FailureFlag[]>(endpointWithParams, {})
}

export function useGetFailureFlags(
  options?: QueryObserverOptions<FailureFlag[], AxiosError>
): UseQueryResult<FailureFlag[]> {
  const { currentTeamId } = useAuth()

  return useQuery<FailureFlag[], AxiosError>({
    ...options,
    queryKey: failureFlagsQueryKeys.getFlags(currentTeamId),
    queryFn: fetchFailureFlags
  })
}
